export default {
    path: "/task",
    name: "task",
    meta: {
        icon: "md-calendar",
        access: "menu_task",
        title: "分配任务",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "task-home",
            name: "task-home",
            meta: {
                icon: "md-list-box",
                access: "menu_task_list",
                title: "任务列表",
            },
            component: () => import("@/views/task/task.vue"),
        },
        // {
        //     path: 'profunc',
        //     meta: {
        //         icon: 'md-calendar',
        //         access: 'menu_project_fun',
        //         title: '功能'
        //     },
        //     component: () =>
        //         import ('@/views/parent-view.vue'),
        //     children: [{
        //             path: 'prosurvey',
        //             name: 'prosurvey',
        //             meta: {
        //                 icon: 'md-people',
        //                 access: 'menu_project_survey',
        //                 title: '概览'
        //             },
        //             component: () =>
        //                 import ('@/views/project/prosurvey.vue')
        //         }, {
        //             path: 'task-list',
        //             name: 'task-list',
        //             meta: {
        //                 icon: 'md-list-box',
        //                 access: 'menu_task_list',
        //                 title: '任务列表'
        //             },
        //             component: () =>
        //                 import ('@/views/task/task.vue')
        //         },
        //         {
        //             path: 'kanban',
        //             name: 'kanban',
        //             meta: {
        //                 icon: 'md-list-box',
        //                 access: 'menu_task_list',
        //                 title: '任务看板'
        //             },
        //             component: () =>
        //                 import ('@/views/task/kanban.vue')
        //         },
        //         {
        //             path: 'prodynamic',
        //             name: 'prodynamic',
        //             meta: {
        //                 icon: 'md-people',
        //                 access: 'menu_project_dynamic',
        //                 title: '动态'
        //             },
        //             component: () =>
        //                 import ('@/views/project/prodynamic.vue')
        //         }
        //     ]
        // }
    ],
};
